import { Action } from '@ngrx/store';

export const SET_READONLY = '[Transacciones] Set Readonly';

export class SetReadonly implements Action {
    readonly type = SET_READONLY;
    constructor(public payload: boolean) {}
}

export type ReadonlyActions = SetReadonly;
